import '@adornis/calendar/calendar.js';
import { css } from '@adornis/chemistry/directives/css.js';
import { ChromiumButton } from '@chancenwerk/design/components/cr-button.js';
import '@chancenwerk/design/components/cr-card.js';
import '@chancenwerk/design/components/cr-flex.js';
import '@chancenwerk/design/components/cr-link.js';
import '@chancenwerk/design/components/cr-loader.js';
import '@chancenwerk/design/components/fonts.js';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import deleteSVG from '../assets/delete.svg';

/**
 * @customElement logistik-component-delete-button
 */
@customElement('logistik-component-delete-button')
export class LogistikComponentDeleteButton extends ChromiumButton {
  override styles() {
    return [
      ...super.styles(),
      {
        ':host([mode=outline])': {
          border: `1px solid ${this.colors.tone.error}`,
        },
      },
    ];
  }

  constructor() {
    super();

    this.mode = 'outline';
  }

  override render() {
    return html`
      <cr-flex
        ${css({
          padding: `${this.spacing.xs} ${this.spacing.md}`,
          borderColor: `${this.colors.tone.error}`,
        })}
      >
        <img src=${deleteSVG} ${css({ width: '16px' })} />
      </cr-flex>
    `;
  }
}
